export default __webpack_public_path__ + "static/Simple_Bed-40637eab317914045bc2dbb3b63b0735.png";